
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/att",
      function () {
        return require("private-next-pages/customers/att.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/att"])
      });
    }
  